export const heroSliderImages = [
  {
    url: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20deep%20emerald%20green%20and%20black%20tones%2C%20mysterious%20floating%20geometric%20shapes%2C%20dramatic%20spotlight%20beams%20cutting%20through%20darkness%2C%20modern%20editorial%20design%20aesthetic%2C%20high%20contrast%20with%20deep%20rich%20shadows%20and%20bright%20rim%20lighting%2C%20sophisticated%20moody%20atmosphere%2C%20artistic%20negative%20space%2C%20no%20human%20figures%2C%20elegant%20atmospheric%20depth%20with%20subtle%20texture&width=1920&height=1080&seq=hero-main-bg-v2&orientation=landscape",
  },
];

export const featureArticles = [
  {
    id: 1,
    slug: "top-influencer-live-fail",
    title: "顶流网红直播翻车现场：千万粉丝博主人设崩塌全记录",
    tag: "独家爆料",
    category: "网红黑料",
    date: "2026-07-06",
    views: 1280000,
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20studio%20lighting%20scene%20with%20shadowy%20abstract%20figure%20silhouette%20against%20dark%20emerald%20background%2C%20moody%20atmosphere%2C%20editorial%20magazine%20photography%20style%2C%20mysterious%20and%20intriguing%20composition%2C%20soft%20rim%20lighting%20creating%20tension%2C%20cinematic%20color%20grading%20with%20deep%20greens%20and%20blacks%2C%20artistic%20blur%20effects%2C%20empty%20space%20for%20text%20overlay&width=800&height=1120&seq=feature-01&orientation=portrait",
  },
  {
    id: 2,
    slug: "chat-records-leak",
    title: "某知名博主私密聊天记录外泄，内容劲爆引全网热议",
    tag: "聊天记录",
    category: "明星爆料",
    date: "2026-07-05",
    views: 965000,
    imageUrl: "https://readdy.ai/api/search-image?query=Close-up%20abstract%20composition%20of%20fragmented%20text%20messages%20on%20dark%20surface%2C%20warm%20amber%20and%20sage%20green%20color%20palette%2C%20mysterious%20digital%20communication%20theme%2C%20soft%20focus%20artistic%20photography%2C%20glowing%20screen%20reflections%2C%20intimate%20and%20secretive%20atmosphere%2C%20editorial%20style%20with%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20aesthetic&width=800&height=520&seq=feature-02&orientation=landscape",
  },
  {
    id: 3,
    slug: "contrast-blogger-exposed",
    title: "反差萌博主真实身份大曝光，甜美形象背后另有隐情",
    tag: "反差视频",
    category: "反差视频",
    date: "2026-07-04",
    views: 845000,
    imageUrl: "https://readdy.ai/api/search-image?query=Dual-tone%20abstract%20composition%20split%20between%20soft%20pink%20and%20dark%20muted%20teal%2C%20contrasting%20textures%20and%20moods%2C%20artistic%20duality%20concept%2C%20modern%20editorial%20photography%2C%20mysterious%20and%20thought-provoking%20atmosphere%2C%20soft%20gradient%20blending%2C%20sophisticated%20color%20palette%20with%20warm%20and%20cool%20tones%2C%20magazine%20cover%20style%20with%20elegant%20negative%20space&width=800&height=520&seq=feature-03&orientation=landscape",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "吃瓜小能手",
    handle: "@chigua_master",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20in%20warm%20beige%20tones%2C%20simple%20geometric%20circular%20design%2C%20soft%20gradient%20background%2C%20modern%20flat%20illustration%20style%2C%20professional%20yet%20friendly%20aesthetic%2C%20clean%20lines%20and%20subtle%20texture&width=80&height=80&seq=avatar-01&orientation=squarish",
    comment: "51吃瓜网真的是我每天的快乐源泉！更新速度超快，很多爆料都是在这里第一时间看到的。界面也很清爽，浏览体验一级棒。",
    date: "2小时前",
  },
  {
    id: 2,
    name: "八卦研究员",
    handle: "@gossip_pro",
    avatar: "https://readdy.ai/api/search-image?query=Abstract%20geometric%20avatar%20with%20muted%20sage%20green%20palette%2C%20minimalist%20circular%20design%2C%20soft%20modern%20illustration%20style%2C%20subtle%20gradient%20tones%2C%20clean%20and%20sophisticated%20aesthetic%2C%20professional%20friendly%20feel&width=80&height=80&seq=avatar-02&orientation=squarish",
    comment: "作为一个资深吃瓜人，用过很多平台，最后还是回到51吃瓜。内容质量高，分类清晰，找瓜特别方便。强烈推荐！",
    date: "5小时前",
  },
  {
    id: 3,
    name: "熬夜冠军",
    handle: "@night_owl_king",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20abstract%20circular%20avatar%20in%20warm%20terracotta%20tones%2C%20minimalist%20geometric%20design%2C%20soft%20gradient%20background%2C%20modern%20flat%20illustration%2C%20friendly%20and%20approachable%20aesthetic%2C%20clean%20smooth%20lines&width=80&height=80&seq=avatar-03&orientation=squarish",
    comment: "每天晚上必刷51吃瓜，不看都睡不着觉。评论区也特别有意思，瓜友们个个是人才，看评论比看瓜还有意思哈哈。",
    date: "8小时前",
  },
  {
    id: 4,
    name: "娱乐圈观察家",
    handle: "@ent_watcher",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20design%20with%20soft%20taupe%20and%20cream%20palette%2C%20abstract%20geometric%20style%2C%20subtle%20gradient%20background%2C%20modern%20flat%20illustration%2C%20professional%20clean%20aesthetic%2C%20gentle%20warm%20tones&width=80&height=80&seq=avatar-04&orientation=squarish",
    comment: "51吃瓜的信息核实做得比很多大平台都好，很少看到假消息。这种对内容负责的态度真的很难得，值得信赖。",
    date: "12小时前",
  },
  {
    id: 5,
    name: "瓜田守望者",
    handle: "@melon_watcher",
    avatar: "https://readdy.ai/api/search-image?query=Abstract%20circular%20avatar%20in%20muted%20olive%20green%20tones%2C%20simple%20geometric%20design%2C%20soft%20gradient%20background%2C%20modern%20minimalist%20illustration%2C%20friendly%20warm%20aesthetic%2C%20clean%20lines&width=80&height=80&seq=avatar-05&orientation=squarish",
    comment: "朋友推荐来的，一用就停不下来了。APP也特别好用，推送及时，再也不用担心错过任何大瓜了。给技术团队点赞！",
    date: "1天前",
  },
  {
    id: 6,
    name: "爆裂吃瓜人",
    handle: "@boom_watcher",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20abstract%20circular%20avatar%20with%20warm%20coral%20and%20cream%20palette%2C%20minimalist%20geometric%20design%2C%20soft%20gradient%2C%20modern%20flat%20illustration%20style%2C%20friendly%20inviting%20aesthetic%2C%20clean%20smooth%20shapes&width=80&height=80&seq=avatar-06&orientation=squarish",
    comment: "这个平台的视频资源真的太全了！很多其他平台下架的视频这里都能找到。而且分类特别细致，想找什么类型的一搜就有。",
    date: "2天前",
  },
];